{
  "general.loading": "Loading...",
  "general.success": "Done",
  "site_type_select.label": "Select development site:",
  "site_type_select.pick_existing_site": "Select an existing site:",
  "site_type_select.create_new_dev_site": "Create a new development site",
  "site_type_select.create_new_dev_site.disabled": "You have reached the maximum number of {limit} development sites.",
  "site_type_select.create_new_harmony_site": "Create a new Harmony Development Site",
  "site_type_select.no_sites": "No sites found.",
  "create_dev_site.loading": "Creating your new development site...",
  "create_dev_site.success": "Development site <0>{name}</0> created.",
  "site_list_select.label": "Select Site:",
  "install_app_on_site.warning": "Your new app needs to be installed on the selected development site.",
  "install_app_on_site.warning.instructions": "Press <0/> to install the app in your browser.",
  "install_app_on_site.finished_successfully": "App installed."
}
